import { element } from 'protractor';
import { Directive, HostListener, ElementRef, Renderer2, AfterViewInit } from '@angular/core';


export class ChSlideToggleDirective implements AfterViewInit {
  active = false;
  state = 'overturnSub';
  index = 0;
  constructor(private elementRef: ElementRef, private renderer: Renderer2) { }
  ngAfterViewInit() {
    // console.log(this.elementRef.nativeElement.querySelector('.active'))
  }

  
  onHostClick($event) {
    const isContainsParent = $event.target.contains(this.elementRef.nativeElement.querySelector('.ch-sidebar-parent'));
    const isContainsI = $event.target.contains(this.elementRef.nativeElement.querySelector('.sid-parent-i'));
    const isContainsSpan = $event.target.contains(this.elementRef.nativeElement.querySelector('.sid-parent-span'));
    const isContainsB = $event.target.contains(this.elementRef.nativeElement.querySelector('.sid-parent-b'));
    if (isContainsParent || isContainsI || isContainsSpan || isContainsB) {
      this.active = !this.active;
      this.getHeight();
      this.toggle();
    }
  }

  getHeight() {
    this.index = 0;
    const child = this.elementRef.nativeElement.querySelector('.sidebar-childlist');
    const array = child.childNodes;
    array.forEach(element => {
      if (element.nodeName === 'SIDEBARITEM') {
        this.index = this.index + 1;
      }
    });
  }



  toggle() {
    if (this.active) {
      this.renderer.addClass(this.elementRef.nativeElement, this.state);
      this.renderer.setStyle(this.elementRef.nativeElement.querySelector('.sidebar-childlist'), 'height', (this.index * 42) + 'px');
      return;
    }
    this.renderer.removeClass(this.elementRef.nativeElement, this.state);
    this.renderer.removeStyle(this.elementRef.nativeElement.querySelector('.sidebar-childlist'), 'height');
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[chSlideToggle]'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'onHostClick': [{ type: HostListener, args: ['click', ['$event'], ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
